export default {"src":"/_next/static/media/ring.fe08d533.svg","height":312,"width":312};